import { Theme } from "@mui/material/styles";

export default function Stepper(theme: Theme) {
    return {
        MuiStepConnector: {
            styleOverrides: {
                line: {
                    borderColor: theme.palette.divider,
                },
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                label: {
                    fontWeight: theme.typography.fontWeightRegular,
                    "&.Mui-completed": {
                        fontWeight: theme.typography.fontWeightRegular,
                    },
                    "&.Mui-disabled": {
                        fontWeight: theme.typography.fontWeightRegular,
                    },
                },
            },
        },
    };
}
